import { Helper } from '../../common/';
import {
    WidgetBase,
    IValidatedValueSelectionConfiguration,
    IWidgetControl,
    IControlWidget
} from '../';
import { IBindable, IIconable } from '../../models';

export class ValidatedValueSelectionWidget extends WidgetBase implements IControlWidget {
    baseType = 'ValidatedValueSelection';
    col = 0;
    configuration = {
        actionItems: [
            {
                icon: 'fa-thumbs-o-up'
            } as IIconable
        ]
    } as IValidatedValueSelectionConfiguration;
    ctrl: IWidgetControl;
    displayName: string;
    guid: string;
    hasExtendedProperties = false;
    highlights = [];
    icon = '';
    isTitleHidden = false;
    name = 'Validated value selection';
    row = 0;
    sizeX = 4;
    sizeY = 12;
    type = 'ValidatedValueSelection';

    constructor() {
        super();
        this.guid = Helper.getGuid();
        if (this.configuration.showShortComment === undefined) {
            this.configuration.showShortComment = false;
        }
        if (this.configuration.showTagName === undefined) {
            this.configuration.showTagName = true;
        }
        if (this.configuration.showUnit === undefined) {
            this.configuration.showUnit = true;
        }
        if (!this.configuration.taskOptionsOverride) {
            this.configuration.taskOptionsOverride = { includeDependent: true };
        }
        if (this.configuration) {
            this.configuration.showComment = !this.configuration.hideComment;
        }
    }

    getSeries(): IBindable[] {
        const self = this;
        return [{
            set guid(value) {
                self.configuration.group = value;
            },
            get guid() {
                return self.configuration.group;
            },
            //guid: this.configuration.group,
            originalGuid: this.configuration.group,
            isBoundToGroup: this.configuration.isBound,
            value: ''
        }];
    }
}